import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen",
  "use": "icon-fullscreen-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fullscreen\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 14.5C2.44772 14.5 2 14.0523 2 13.5V3.5C2 2.94771 2.44772 2.5 3 2.5H13C13.5523 2.5 14 2.94772 14 3.5L14 13.5C14 14.0523 13.5523 14.5 13 14.5L3 14.5ZM3 13.5L3 3.5L13 3.5L13 13.5L3 13.5Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol